import { IconInfoCircle } from '@tabler/icons-react'
import React, { useState } from 'react'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import HowToEarnPoints from '../../leaderboard/components/model/HowToEarnPoints'
import { EarnPointsText, StyledPopover } from '../styled/HowToEarn.style'

interface HowToEarnProps {
  isAuthenticated: boolean
}

const HowToEarn: React.FC<HowToEarnProps> = ({ isAuthenticated }) => {
  const { theme } = useAppUtilities()
  const [anchorEarnEl, setAnchorEarnEl] = useState<HTMLElement | null>(null)
  const openEarnPopover = Boolean(anchorEarnEl)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEarnEl(event.currentTarget)
  }

  const handlePopoverClose = (): void => {
    setAnchorEarnEl(null)
  }
  return (
    <>
      <EarnPointsText
        color={isAuthenticated ? 'white' : 'primary.main'}
        aria-owns={
          openEarnPopover ? 'earn-point-mouse-over-popover' : undefined
        }
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        noWrap
      >
        Earn Points{' '}
        <IconInfoCircle
          stroke={2}
          size={'18px'}
          color={theme.palette.warning[500]}
        />
      </EarnPointsText>

      <StyledPopover
        open={openEarnPopover}
        anchorEl={anchorEarnEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        slotProps={{
          paper: {
            sx: {
              p: 3,
              borderRadius: '16px',
            },
          },
        }}
      >
        <HowToEarnPoints />
      </StyledPopover>
    </>
  )
}

export default HowToEarn
